import React, { createContext, useContext, useState, useCallback } from 'react';

const LoadingContext = createContext();

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};

export const LoadingProvider = ({ children }) => {
  const [loadingStates, setLoadingStates] = useState(new Map());
  const [isGlobalLoading, setIsGlobalLoading] = useState(false);

  // Ajouter un état de chargement
  const addLoadingState = useCallback((key) => {
    setLoadingStates(prev => {
      const newStates = new Map(prev);
      newStates.set(key, true);
      return newStates;
    });
  }, []);

  // Supprimer un état de chargement
  const removeLoadingState = useCallback((key) => {
    setLoadingStates(prev => {
      const newStates = new Map(prev);
      newStates.delete(key);
      return newStates;
    });
  }, []);

  // Mettre à jour l'état de chargement global
  React.useEffect(() => {
    const hasAnyLoading = loadingStates.size > 0;
    setIsGlobalLoading(hasAnyLoading);
  }, [loadingStates]);

  const value = {
    isGlobalLoading,
    addLoadingState,
    removeLoadingState,
    loadingStates
  };

  return (
    <LoadingContext.Provider value={value}>
      {children}
    </LoadingContext.Provider>
  );
}; 